import React, { useEffect, useState } from "react";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";
import { Link } from "react-router-dom";
import Package from "../components/Dashboard/Package.js";
import { Tooltip } from "react-tooltip";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import copy from "copy-to-clipboard";
import { useSelector } from "react-redux";
import { connection } from "../helper/connection";
import { toastAlert } from "../helper/toastAlert";
import YezABI from "../ABI/YezABI.json";
import USDTTokenABI from "../ABI/USDTTokenABI.json";
import config from "../config/config";
import RotateLoader from "react-spinners/RotateLoader";
import { Multicall } from "ethereum-multicall";
import BigNumber from "bignumber.js";
import {
  FacebookShareButton,
  FacebookIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon
} from "react-share";
import { convert } from "../helper/convert.js";

const override = {
  // display: "block",
  // margin: "0 auto",
  borderColor: "#20403e",
  position: "fixed",
  top: "50%",
  left: "50%",
  marginLeft: "-32px",
  marginTop: "-32px",
  zIndex: "99999"
};
// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
export default function Dashboard(props) {
  const [loading, setLoading] = useState(false);
  const [reInvestAmount, setReInvestAmount] = useState(0);
  const walletConnection = useSelector((state) => state.walletConnection);
  const [UserData, setUserData] = useState([]);
  const [userRefCount, setUserRefCount] = useState(0);
  const [teamCont, setTeamCont] = useState(0);
  const [levelCount, setLevelCount] = useState([]);
  const [directReward, setDirectReward] = useState(0);
  const [poolInfos, setPoolInfos] = useState([]);

  var package_slider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  useEffect(() => {
    userChecking();
    getUserDetails();
    getUserPoolDetails();
    getLevelCountData();
  }, [walletConnection.address]);

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("wagmi.store")).state.data.account == null
    ) {
      window.location.href = "/";
    }
  }, []);

  async function bignumber(inputs) {
    let ten = new BigNumber(inputs.hex, 16);
    var value = ten.toString(10);
    return value;
  }
  async function userChecking() {
    if (
      walletConnection &&
      walletConnection.address &&
      walletConnection.address != undefined &&
      walletConnection.address != null &&
      walletConnection.address != ""
    ) {
      let web3 = walletConnection.web3;
      var YezContract = new web3.eth.Contract(YezABI, config.YezContAddr);
      let userDetails = await YezContract.methods
        .users(walletConnection.address)
        .call();
      console.log(userDetails, "userDetailsuserDetails");
      if (!userDetails.isExist) {
        window.location.href = "/";
      }
    }
  }

  const getUserDetails = async () => {
    try {
      var get = await connection();
      if (get && get.web3 && get.address) {
        let address = get.address;
        const multicall = new Multicall({
          web3Instance: get.web3
        });

        let contractData = [
          {
            reference: "details",
            contractAddress: config.YezContAddr,
            abi: YezABI,
            calls: [
              {
                reference: "userprofile",
                methodName: "users",
                methodParameters: [address]
              },
              {
                reference: "userRefs",
                methodName: "viewUserReferals",
                methodParameters: [address]
              },
              {
                reference: "referalReward",
                methodName: "viewLevelRewards",
                methodParameters: [address]
              },
              {
                reference: "overAllTeam",
                methodName: "overAllTeam",
                methodParameters: [address]
              }
            ]
          }
        ];
        const results = await multicall.call(contractData);
        console.log(results, "results");
        let userprofile = await getFormatMulticall(results, "userprofile", 0);
        let referals = await getFormatMulticall(results, "userRefs", 0);
        let referalsReward = await getFormatMulticall(
          results,
          "referalReward",
          0
        );
        let teamCount = await getFormatMulticall(results, "overAllTeam", 0);
        console.log(
          referals,
          "referals12",
          await bignumber(referalsReward[1]),
          await bignumber(userprofile[4])
        );
        setUserRefCount(referals.length);
        setTeamCont(await bignumber(teamCount[0]));
        setDirectReward(await bignumber(referalsReward[1]));
        if (userprofile[0]) {
          let userexist = true;
          let userID = await bignumber(userprofile[1]);
          let refererAddress = userprofile[2];
          let referrerID = await bignumber(userprofile[3]);
          let levelRewardTotal = await bignumber(userprofile[4]);
          let rewardAmount = await bignumber(userprofile[5]);
          let withdrawAmount = await bignumber(userprofile[6]);
          let totalInvestment = await bignumber(userprofile[7]);
          let joinedDate = await bignumber(userprofile[8]);

          let UserData = {
            userexist: userexist,
            userID: userID,
            refererAddress: refererAddress,
            referrerID: referrerID,
            rewardAmount: rewardAmount,
            levelRewardTotal: levelRewardTotal,
            withdrawAmount: withdrawAmount,
            totalInvestment: totalInvestment,
            joinedDate: joinedDate
          };
          setUserData(UserData);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //Demo
  // function getDaysDifference(lastClaimedDate) {
  //   const currentDate = new Date();
  //   const differenceInMs = lastClaimedDate - currentDate;
  //   const dayDifference = Math.floor(differenceInMs / (1000 * 60));
  //   // const dayDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
  //   console.log(dayDifference, "dayDifference");
  //   if (dayDifference <= 15) {
  //     return 15 - dayDifference; //90
  //   } else {
  //     return 0;
  //   }
  //   // return dayDifference;
  // }

  function getDaysDifference(lastClaimedDate, JoinDate) {
    const currentDate = new Date();
    const differenceInMs = currentDate - JoinDate;
    // const dayDifference = Math.floor(differenceInMs / (1000 * 60));
    const dayDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    console.log(dayDifference, "dayDifference");
    // if (dayDifference <= 90) {
    //   return 90 - dayDifference; //90
    // } else {
    //   return 0;
    // }
    return dayDifference >= 90 ? 90 : dayDifference;
  }

  //Demo
  // const getMonthandReward = async (poolInfo) => {
  //   if (Number(poolInfo.ClaimCount) === 20) return { month: 0, reward: 0 };

  //   const amountInvested = Number(poolInfo?.amountInvested) / 1e18;
  //   const reward = (amountInvested * 10) / 100;
  //   const lastClaimedDate = new Date(Number(poolInfo.lastCliameddate) * 1000);
  //   const currentDate = new Date();
  //   const differenceInMinutes = (currentDate - lastClaimedDate) / (1000 * 60);
  //   let differenceInMonths = Math.floor(differenceInMinutes / 5);
  //   differenceInMonths +=
  //     Number(poolInfo?.ClaimCount) >= 20 ? 20 : Number(poolInfo?.ClaimCount);

  //   let monthsAfter90Minutes = 0;
  //   if (differenceInMinutes > 15 || differenceInMonths <= (20 * 24 * 60) / 5) {
  //     monthsAfter90Minutes = Math.max(
  //       0,
  //       differenceInMonths >= 20
  //         ? 20 - Number(poolInfo.ClaimCount)
  //         : differenceInMonths - Number(poolInfo.ClaimCount)
  //     );
  //   }
  //   return {
  //     month: monthsAfter90Minutes,
  //     reward: Math.max(0, monthsAfter90Minutes * reward)
  //   };
  // };

  const getMonthandReward = async (poolInfo) => {
    const CLAIM_LIMIT = 20;
    const REWARD_RATE = 0.1; // 10% reward rate
    const MINUTES_IN_DAY = 24 * 60;
    const MINUTES_IN_90_DAYS = 90 * 24 * 60;
    console.log(poolInfo, "poolInfo");
    if (Number(poolInfo.ClaimCount) >= CLAIM_LIMIT) {
      return { month: 0, reward: 0 }; // No reward if claim count reached the limit
    }

    const amountInvested = Number(poolInfo?.amountInvested) / 1e18;
    const reward = amountInvested * REWARD_RATE;

    const lastClaimedDate = new Date(Number(poolInfo.lastCliameddate) * 1000);
    const currentDate = new Date();

    const differenceInMinutes = (currentDate - lastClaimedDate) / (1000 * 60);

    if (
      differenceInMinutes < MINUTES_IN_90_DAYS ||
      Number(poolInfo.ClaimCount) >= CLAIM_LIMIT
    ) {
      return { month: 0, reward: 0 };
    }

    const monthsSinceLastClaim = differenceInMinutes / (MINUTES_IN_DAY * 30);

    const monthsAfter90Minutes = Math.max(
      0,
      Math.floor(monthsSinceLastClaim) - CLAIM_LIMIT
    );

    return {
      month: monthsAfter90Minutes,
      reward: Math.max(0, monthsAfter90Minutes * reward)
    };
  };

  const getUserPoolDetails = async () => {
    try {
      if (walletConnection.address) {
        let address = walletConnection.address;
        let web3 = walletConnection.web3;
        let poolDetails = [];
        var YezContract = new web3.eth.Contract(YezABI, config.YezContAddr);
        const poolLength = await YezContract.methods
          .userPoolInfoLength(address)
          .call();
        for (let i = 1; i <= poolLength; i++) {
          const poolInfo = await YezContract.methods
            .userPoolInfo(address, i)
            .call();
          let lastCliameddate = new Date(
            Number(poolInfo.lastCliameddate) * 1000
          );
          let JoinDate = new Date(Number(poolInfo.joinedDate) * 1000);

          let leftDays = await getDaysDifference(lastCliameddate, JoinDate);
          let monthReward = await getMonthandReward(poolInfo);
          console.log(monthReward, "monthRewardmonthReward");
          if (leftDays >= 90) {
            leftDays = 90;
          }
          console.log(
            leftDays,
            "leftDaysleftDaysleftDays",
            lastCliameddate,
            JoinDate
          );
          // console.log(
          //   lastCliameddate.getTime(),
          //   new Date().getTime(),
          //   "Checkkkkkk123",
          //   JoinDate.getTime()
          // );
          // let timeDifference = Math.abs(
          //   lastCliameddate.getTime() - new Date().getTime()
          // );
          // // let leftDays = Math.floor(timeDifference / (1000 * 3600 * 24));
          // let leftDays = Math.floor(timeDifference / (60 * 1000));
          let detailsData = {
            poolId: i,
            joinedDate: new Date(Number(poolInfo.joinedDate) * 1000),
            lastCliameddate: new Date(Number(poolInfo.lastCliameddate) * 1000),
            leftDays: leftDays,
            RewardAmountClaimed: Number(poolInfo.RewardAmountClaimed) / 1e18,
            amountInvested: Number(poolInfo.amountInvested) / 1e18,
            amountInvestedUsdt: Number(poolInfo.amountInvestedUsdt) / 1e18,
            ClaimCount: Number(poolInfo.ClaimCount),
            month: monthReward.month,
            monthReward: monthReward.reward
          };
          console.log(detailsData, "detailsData");
          poolDetails.push(detailsData);
        }
        console.log(poolDetails, "poolDetails");
        setPoolInfos(poolDetails);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getLevelCountData = async () => {
    try {
      if (walletConnection.address) {
        let address = walletConnection.address;
        let web3 = walletConnection.web3;
        var YezContract = new web3.eth.Contract(YezABI, config.YezContAddr);
        let levCounts = [];

        let levWiseCnt = await YezContract.methods
          .viewTeamDetails(address)
          .call();
        console.log(levWiseCnt[0], "levWiseCnt");
        for (let i = 0; i < 9; i++) {
          levCounts.push({
            level: i + 1,
            count: Number(levWiseCnt?.[0]?.[i]),
            investment: Number(levWiseCnt?.[1]?.[i]) / 1e18,
            earning: Number(levWiseCnt?.[2]?.[i]) / 1e18
          });
        }
        setLevelCount(levCounts);
        // levCounts.push({ level: i + 1, value: levWiseCnt });
      }
    } catch (err) {
      console.log(err);
    }
  };

  function getFormatMulticall(results, name, pos) {
    try {
      var index =
        results &&
        results.results &&
        results.results.details &&
        results.results.details.callsReturnContext &&
        results.results.details.callsReturnContext.findIndex(
          (val) => val.reference == name
        );
      var returnVal =
        results.results.details.callsReturnContext[index] &&
        results.results.details.callsReturnContext[index].returnValues
          ? results.results.details.callsReturnContext[index].returnValues
          : "";
      return returnVal;
    } catch (err) {
      console.log(err, "==+++++++==");
      return "";
    }
  }

  const handleStakeAgain = async () => {
    try {
      setLoading(true);
      var get = await connection();
      if (get && get.web3) {
        var web3 = get.web3;
        var address = get.address;
        if (reInvestAmount == "" || isNaN(reInvestAmount)) {
          setLoading(false);
          toastAlert("error", "Enter valid amount");
          return false;
        }
        if (reInvestAmount < 5) {
          setLoading(false);
          toastAlert("error", "Amount must be greater than 5 USDT");
          return false;
        }
        let YezContract = new web3.eth.Contract(YezABI, config.YezContAddr);

        let PlanAmount = convert(reInvestAmount * 1e18); //UseState Here
        let USDTContract = new web3.eth.Contract(
          USDTTokenABI,
          config.USDTToken
        );
        let USDTToken = await USDTContract.methods
          .balanceOf(address.toString())
          .call();
        USDTToken = USDTToken / 1e18;
        console.log(USDTToken, Number(PlanAmount) / 1e18, "checkBalance");
        if (Number(USDTToken) < Number(PlanAmount) / 1e18) {
          setLoading(false);
          toastAlert("error", "Insufficient Balance (USDT)");
          return false;
        }
        let bnbBalance = await web3.eth.getBalance(address);
        bnbBalance = web3.utils.fromWei(bnbBalance, "ether");
        const gasLimit = await USDTContract.methods
          .approve(config.YezContAddr, PlanAmount.toString())
          .estimateGas({ from: address });
        const gasFee = gasLimit * (await web3.eth.getGasPrice());
        console.log(gasFee, "gasFee", bnbBalance);
        if (bnbBalance < gasFee / 1e18) {
          setLoading(false);
          toastAlert("error", "Insufficient BNB Balance for Gas Fee");
          return false;
        }

        await USDTContract.methods
          .approve(config.YezContAddr, PlanAmount.toString())
          .send({ from: address.toString() })
          .then(async (approveRes) => {
            if (approveRes.status == true && approveRes.transactionHash) {
              await YezContract.methods
                .reJoinUser(PlanAmount.toString())
                .send({ from: address })
                .then(async (registerRes) => {
                  if (
                    registerRes.status == true &&
                    registerRes.transactionHash
                  ) {
                    toastAlert("success", "Re-Stake Successfully Completed");
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                    return false;
                  } else {
                    setLoading(false);
                    toastAlert("error", "Stake failed, try again later");
                    return false;
                  }
                })
                .catch((err) => {
                  setLoading(false);
                  toastAlert("error", "Catch error, try again later");
                  return false;
                });
            } else {
              setLoading(false);
              toastAlert("error", "Approve failed, please try again");
              return false;
            }
          })
          .catch((err) => {
            setLoading(false);
            toastAlert("error", "Catch error, try again later");
            return false;
          });
      } else {
        setLoading(false);
        toastAlert("error", "Connect your wallet");
        return false;
      }
    } catch (err) {
      console.log("errrr: ", err);
      setLoading(false);
    }
  };

  async function copyToClipboard(urll) {
    if (walletConnection.address) {
      copy(urll);
      toastAlert("success", "Copied Successfully");
    } else {
      toastAlert("error", "Please connect your wallet");
    }
  }

  return (
    <>
      <div>
        <ScrollToTopOnMount />
        <Navbar />
        <div className="inner_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="flex_maintitle">
                  <h2 className="inner_head_title">Dashboard</h2>
                  <button
                    className="primary_btn"
                    data-bs-toggle="modal"
                    data-bs-target="#invest_modal"
                  >
                    <span>Invest More</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="row align-items-center dash_height_row">
              <div className="col-lg-12">
                <div className="dash_top_box">
                  <div className="dash_black_box_panel">
                    <div className="affiliate_link_box">
                      <h2>YEZBIT {UserData.userID}</h2>
                      <div className="inp_grp">
                        <input
                          className="form-control affiliate_inp"
                          defaultValue={
                            config.frontUrl + "/" + walletConnection?.address
                          }
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="affiliate_icon"
                          onClick={() =>
                            copyToClipboard(
                              config.frontUrl + "/" + walletConnection.address
                            )
                          }
                        >
                          <path
                            d="M16.0348 6.57854L11.4509 9.2245M11.4509 14.7755L16.0348 17.4215M12.1871 12C12.1871 15.0891 9.68288 17.5932 6.59383 17.5932C3.50478 17.5932 1.00061 15.0891 1.00061 12C1.00061 8.91095 3.50478 6.40678 6.59383 6.40678C9.68288 6.40678 12.1871 8.91095 12.1871 12ZM8.45824 12C8.45824 13.0297 7.62351 13.8644 6.59383 13.8644C5.56415 13.8644 4.72942 13.0297 4.72942 12C4.72942 10.9703 5.56415 10.1356 6.59383 10.1356C7.62351 10.1356 8.45824 10.9703 8.45824 12ZM23.0006 4.72881C23.0006 6.78818 21.3312 8.45763 19.2718 8.45763C17.2124 8.45763 15.543 6.78818 15.543 4.72881C15.543 2.66945 17.2124 1 19.2718 1C21.3312 1 23.0006 2.66945 23.0006 4.72881ZM23.0006 19.2712C23.0006 21.3306 21.3312 23 19.2718 23C17.2124 23 15.543 21.3306 15.543 19.2712C15.543 17.2118 17.2124 15.5424 19.2718 15.5424C21.3312 15.5424 23.0006 17.2118 23.0006 19.2712Z"
                            stroke="#9F9F9F"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <ul className="share_list">
                        <li>
                          <FacebookShareButton
                            url={`${config.frontUrl}/${walletConnection.address}`}
                          >
                            <a href="#" target="_blank">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="13"
                                height="22"
                                viewBox="0 0 13 22"
                                fill="none"
                              >
                                <path
                                  d="M12.2009 5.00004V0.999999H7.53401C5.70069 0.999999 4.20065 2.49996 4.20065 4.33332V8.99996H1.00061V13H4.20065V21H8.20078V13H11.4009L12.2009 8.99996H8.20078V5.00004H12.2009Z"
                                  stroke="#fff"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </a>
                          </FacebookShareButton>
                        </li>
                        <li>
                          <TwitterShareButton
                            url={`${config.frontUrl}/${walletConnection.address}`}
                          >
                            <a href="#" target="_blank">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="21"
                                height="20"
                                viewBox="0 0 21 20"
                                fill="none"
                              >
                                <path
                                  d="M7.9598 11.1223L0.138815 0.0410549C0.360965 0.0274505 0.501912 0.0102183 0.643789 0.0102183C2.30805 0.0102183 3.9723 0.0174741 5.63749 0.00114887C5.95858 0.00114887 6.14153 0.109077 6.31701 0.359397C7.83908 2.5361 9.36861 4.70463 10.9056 6.86501L11.2584 7.36565C11.4124 7.20149 11.5459 7.06545 11.6719 6.92396C13.5891 4.75724 15.512 2.60049 17.4133 0.421977C17.6821 0.114519 17.9537 -0.0315017 18.3644 0.00568359C18.6977 0.0347063 19.0356 0.0120323 19.5135 0.0120323L12.0406 8.47577C14.7298 12.285 17.4086 16.0797 20.1342 19.9406C19.9316 19.9606 19.8037 19.9842 19.6768 19.9842C17.9967 19.9842 16.3165 19.9769 14.6364 19.9932C14.3116 19.9932 14.1352 19.8762 13.9606 19.6304C12.3427 17.3195 10.7171 15.0134 9.08362 12.7122C8.97908 12.5643 8.87173 12.4183 8.73638 12.2306C8.41623 12.5861 8.12034 12.9108 7.83005 13.2391C5.95298 15.3578 4.07218 17.4737 2.20817 19.6041C1.96362 19.8826 1.7228 20.0295 1.3401 19.995C0.988211 19.9633 0.631659 19.9887 0.134155 19.9887L7.9598 11.1223ZM2.49752 1.28359C2.62353 1.47496 2.69168 1.58833 2.76915 1.69625C6.61383 7.04731 10.479 12.3893 14.2845 17.7685C14.8324 18.543 15.3794 18.943 16.3483 18.7942C16.7907 18.7253 17.2537 18.7824 17.7867 18.7824C17.6448 18.5702 17.5729 18.455 17.4936 18.3453C15.2864 15.2725 13.0773 12.2003 10.8664 9.12878C9.07864 6.63767 7.28868 4.14837 5.49655 1.66088C5.378 1.49763 5.15773 1.30898 4.97665 1.2981C4.18979 1.26091 3.39172 1.28359 2.49752 1.28359Z"
                                  fill="#fff"
                                />
                              </svg>
                            </a>
                          </TwitterShareButton>
                        </li>
                        <li>
                          <TelegramShareButton
                            url={`${config.frontUrl}/${walletConnection.address}`}
                          >
                            <a href="#" target="_blank">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="19"
                                viewBox="0 0 22 19"
                                fill="none"
                              >
                                <path
                                  d="M5.86939 10.5463L16.6913 5.01755L9.7505 12.3926L8.52253 17.3661M9.78324 12.4192L16.2961 17.6635M19.7246 1.38251L1.74183 8.2471C0.829675 8.59528 0.844696 9.1222 1.77507 9.41818L5.8151 10.5742L7.93871 16.647C8.26095 17.5686 9.11223 17.7814 9.8304 17.1202L12.5322 14.6326L16.329 17.6899C17.1005 18.2882 17.8902 17.9948 18.084 17.0381L21.0304 2.48915C21.2242 1.53239 20.6366 1.03446 19.7246 1.38251Z"
                                  stroke="#fff"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </a>
                          </TelegramShareButton>
                        </li>
                        <li>
                          <WhatsappShareButton
                            url={`${config.frontUrl}/${walletConnection.address}`}
                          >
                            <a href="#" target="_blank">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                              >
                                <path
                                  d="M2.2721 15.8726L3.00006 16.0531C3.04605 15.8677 3.01952 15.6717 2.92589 15.5051L2.2721 15.8726ZM6.128 19.7285L6.4955 19.0747C6.32894 18.9811 6.13293 18.9546 5.94748 19.0006L6.128 19.7285ZM1.00061 21L0.272659 20.8195C0.209372 21.0747 0.284354 21.3444 0.47028 21.5303C0.656206 21.7163 0.925919 21.7912 1.18113 21.728L1.00061 21ZM9.8278 12.1728L9.29662 12.7023L9.2983 12.7039L9.8278 12.1728ZM8.36125 9.31746L7.83092 8.78713L8.36125 9.31746ZM9.44789 8.44078L9.97822 8.97111L9.44789 8.44078ZM8.67063 5.82319L8.1403 6.35352H8.1403L8.67063 5.82319ZM6.29735 6.02091L6.82768 6.55124L6.82769 6.55123L6.29735 6.02091ZM8.33229 13.6683L7.79935 14.1961L7.80454 14.2012L8.33229 13.6683ZM15.9797 15.7033L16.51 16.2336L16.51 16.2336L15.9797 15.7033ZM16.1774 13.33L15.647 13.8603L15.6473 13.8605L16.1774 13.33ZM13.5598 12.5527L13.0295 12.0224L13.0294 12.0224L13.5598 12.5527ZM12.6831 13.6393L12.1529 13.1089L12.1528 13.109L12.6831 13.6393ZM2.92589 15.5051C2.17762 14.174 1.75061 12.638 1.75061 11H0.25061C0.25061 12.9021 0.747167 14.6904 1.61832 16.2401L2.92589 15.5051ZM1.75061 11C1.75061 5.91426 5.9149 1.75 11.0006 1.75V0.25C5.08648 0.25 0.25061 5.08583 0.25061 11H1.75061ZM11.0006 1.75C16.0864 1.75 20.2506 5.91426 20.2506 11H21.7506C21.7506 5.08583 16.9148 0.25 11.0006 0.25V1.75ZM20.2506 11C20.2506 16.0857 16.0864 20.25 11.0006 20.25V21.75C16.9148 21.75 21.7506 16.9141 21.7506 11H20.2506ZM11.0006 20.25C9.36261 20.25 7.82663 19.823 6.4955 19.0747L5.7605 20.3823C7.3102 21.2534 9.09852 21.75 11.0006 21.75V20.25ZM5.94748 19.0006L0.820092 20.272L1.18113 21.728L6.30851 20.4565L5.94748 19.0006ZM1.72856 21.1805L3.00006 16.0531L1.54415 15.6921L0.272659 20.8195L1.72856 21.1805ZM10.359 11.6433C10.1727 11.4564 9.69173 10.9319 9.33809 10.4004C9.15767 10.1293 9.04326 9.90453 8.99796 9.74942C8.94513 9.56853 9.03846 9.7009 8.89158 9.84779L7.83092 8.78713C7.38262 9.23543 7.45698 9.82367 7.55812 10.17C7.66679 10.542 7.87932 10.9158 8.08929 11.2314C8.51645 11.8733 9.07018 12.4751 9.29662 12.7023L10.359 11.6433ZM8.89158 9.84779C8.88855 9.85082 8.89689 9.84245 8.9251 9.81895C8.95083 9.7975 8.98427 9.77075 9.02584 9.73832C9.11035 9.6724 9.21019 9.59721 9.32356 9.51106C9.52825 9.35551 9.8051 9.14423 9.97822 8.97111L8.91756 7.91045C8.83221 7.9958 8.64858 8.14002 8.41599 8.31677C8.23232 8.45635 7.96094 8.65711 7.83092 8.78713L8.89158 9.84779ZM9.97822 8.97111C10.3129 8.63647 10.5019 8.24067 10.5364 7.81163C10.5695 7.40051 10.4555 7.02557 10.3078 6.71908C10.0219 6.12592 9.51765 5.60955 9.20096 5.29286L8.1403 6.35352C8.47119 6.68441 8.79573 7.03674 8.95658 7.37043C9.03223 7.52736 9.04617 7.63038 9.04126 7.69139C9.03779 7.73449 9.02302 7.80498 8.91756 7.91045L9.97822 8.97111ZM9.20096 5.29286C9.20496 5.29686 9.16469 5.25505 9.11296 5.2079C9.06037 5.15997 8.98938 5.09989 8.90119 5.03654C8.72713 4.91148 8.47262 4.76401 8.14897 4.67996C7.44019 4.4959 6.59364 4.66393 5.76701 5.49058L6.82769 6.55123C7.08921 6.2897 7.29618 6.18439 7.43597 6.14216C7.57194 6.10108 7.68128 6.10826 7.77194 6.13181C7.98013 6.18587 8.11845 6.33168 8.1403 6.35352L9.20096 5.29286ZM5.76702 5.49058C4.2297 7.0279 4.6548 9.10431 5.35915 10.653C6.08222 12.2428 7.24337 13.6346 7.79937 14.196L8.8652 13.1406C8.39282 12.6635 7.35341 11.4147 6.72456 10.032C6.07699 8.60814 5.99882 7.3801 6.82768 6.55124L5.76702 5.49058ZM7.80454 14.2012C8.366 14.7572 9.75773 15.9184 11.3476 16.6415C12.8963 17.3458 14.9727 17.7709 16.51 16.2336L15.4494 15.1729C14.6205 16.0018 13.3924 15.9236 11.9686 15.2761C10.5859 14.6472 9.33703 13.6078 8.86003 13.1354L7.80454 14.2012ZM16.51 16.2336C17.3367 15.407 17.5047 14.5604 17.3206 13.8516C17.2366 13.5279 17.0891 13.2734 16.964 13.0994C16.9007 13.0112 16.8406 12.9402 16.7926 12.8876C16.7454 12.8358 16.7037 12.7957 16.7075 12.7995L15.6473 13.8605C15.6689 13.8821 15.8147 14.0205 15.8688 14.2287C15.8923 14.3193 15.8995 14.4287 15.8584 14.5646C15.8162 14.7044 15.7109 14.9114 15.4494 15.1729L16.51 16.2336ZM16.7077 12.7997C16.391 12.483 15.8747 11.9788 15.2815 11.6928C14.975 11.5451 14.6001 11.4311 14.1889 11.4642C13.7599 11.4987 13.3641 11.6878 13.0295 12.0224L14.0901 13.0831C14.1956 12.9776 14.2661 12.9628 14.3092 12.9594C14.3702 12.9545 14.4732 12.9684 14.6302 13.044C14.9639 13.2049 15.3162 13.5294 15.647 13.8603L16.7077 12.7997ZM13.0294 12.0224C12.8564 12.1955 12.6451 12.4724 12.4896 12.677C12.4034 12.7904 12.3282 12.8902 12.2623 12.9747C12.2299 13.0163 12.2031 13.0497 12.1817 13.0754C12.1582 13.1036 12.1498 13.112 12.1529 13.1089L13.2134 14.1697C13.3435 14.0397 13.5442 13.7683 13.6838 13.5846C13.8606 13.352 14.0048 13.1684 14.0902 13.083L13.0294 12.0224ZM12.1528 13.109C12.2996 12.9621 12.432 13.0555 12.2511 13.0026C12.096 12.9573 11.8713 12.8429 11.6002 12.6625C11.0687 12.3089 10.5442 11.8279 10.3573 11.6416L9.2983 12.7039C9.52549 12.9304 10.1272 13.4842 10.7692 13.9113C11.0848 14.1213 11.4585 14.3338 11.8306 14.4425C12.1769 14.5436 12.7652 14.618 13.2135 14.1696L12.1528 13.109Z"
                                  fill="#fff"
                                />
                              </svg>
                            </a>
                          </WhatsappShareButton>
                        </li>
                      </ul>
                    </div>
                    <div className="dash_black_box">
                      <h4>Total Investment </h4>
                      <h5>
                        {UserData.totalInvestment
                          ? (Number(UserData.totalInvestment) / 1e18).toFixed(2)
                          : 0}{" "}
                        <span>USDT</span>
                      </h5>
                    </div>
                    <div className="dash_black_box">
                      <h4>Direct Referral Count</h4>
                      <h5>{userRefCount || 0}</h5>
                    </div>
                    <div className="dash_black_box">
                      <h4>Total Team Count</h4>
                      <h5>{teamCont ? teamCont : 0}</h5>
                    </div>
                    <div className="dash_black_box">
                      <h4>Direct Referral Earnings</h4>
                      <h5>
                        {directReward
                          ? (Number(directReward) / 1e18).toFixed(2)
                          : 0}{" "}
                        <span>USDT</span>
                      </h5>
                    </div>
                    <div className="dash_black_box">
                      <h4>Level Income</h4>
                      <h5>
                        {UserData.levelRewardTotal
                          ? (
                              Number(UserData.levelRewardTotal) / 1e18 -
                              Number(directReward) / 1e18
                            ).toFixed(2)
                          : 0}{" "}
                        <span>USDT</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 mt-3">
                {/* For Desktop */}
                <div className="packages_panel packages_panel_desktop">
                  {poolInfos.length > 0 &&
                    poolInfos.map((ele, i) => {
                      console.log(i, "iiiiiiiiiiiiiiiiiiiiii", ele);
                      return <Package key={i} poolData={ele} />;
                    })}

                  {/* <Package /> */}
                </div>

                {/* For Mobile */}
                <div className="packages_panel_mobile">
                  <Slider {...package_slider} className="custom_slider">
                    {poolInfos.length > 0 &&
                      poolInfos.map((ele, i) => {
                        return (
                          <div>
                            <Package key={i} poolData={ele} />
                          </div>
                        );
                      })}{" "}
                    {/* <div>
                      <Package />{" "}
                    </div>{" "}
                    <div>
                      <Package />{" "}
                    </div> */}
                  </Slider>
                </div>
                <div className="dash_top_box mt-4">
                  <div className="table-responsive">
                    <table className="table primary_table">
                      <thead>
                        <tr>
                          <th>Level</th>
                          <th>User Count</th>
                          <th>Investment (USDT)</th>
                          <th>Earnings (USDT)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {levelCount?.length > 0 &&
                          levelCount.map((item, i) => {
                            return (
                              <tr>
                                <td>{i + 1}</td>
                                <td>{item.count}</td>
                                <td>{item.investment.toFixed(2)}</td>
                                <td>{item.earning.toFixed(2)}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {/* Invest Modal */}
      <div
        className="modal fade primary_modal"
        id="invest_modal"
        tabIndex={-1}
        aria-labelledby="invest_modalModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="invest_modalModalLabel">
                Invest
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="form-group mb-3">
                <label className="mb-1">Amount</label>
                <input
                  type="number"
                  className="primary_inp form-control"
                  placeholder="Enter Amount"
                  onKeyDown={(evt) =>
                    ["e", "E", "+", "-", "."].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  onChange={(e) => setReInvestAmount(e.target.value)}
                />
                <div className="default_id mt-2 mb-0">
                  {" "}
                  <p>(Minimum deposit is 5 USDT)</p>
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    className="primary_btn mt-4"
                    onClick={handleStakeAgain}
                  >
                    <span>Reinvest Now</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loadBefore">
          <RotateLoader
            color={"#9dfffa"}
            loading={loading}
            cssOverride={override}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </>
  );
}
